export const formatBulletPoints = benefit => ({
  text: benefit.text,
  icon: {
    imageName: benefit.icon,
    directory: 'dls'
  },
  flag: benefit.flag
});
